import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Asset property - Definition */
export class DocsBlockAssetPropertyDefinition extends DocsBlockPropertyDefinition {
}
